"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const surface_styles_1 = require("@/components/common/surface/surface.styles");
const token_values_1 = require("@/components/domains/component/token-values");
const theme_change_controller_1 = require("@/controllers/theme-change-controller");
require("@/components/common");
/**
 * 토큰 이름과 값을 한 칸으로 보여준다.
 * 값은 자기 자리에서 계산된 스타일로 읽으므로 테마를 바꾸면 그 테마의 값이 그대로 나온다.
 * 이름·값 모두 12px bold로 촘촘히 보여줘야 해서 meta-item 대신 mm-text 두 줄을 직접 쌓는다.
 */
let TokenItem = class TokenItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.themeChange = new theme_change_controller_1.ThemeChangeController(this);
        this.key = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-text size="12" weight="bold" color="light">${this.key}</mm-text>
      <mm-text size="12" weight="bold">${(0, token_values_1.computedTokenValue)(this.key, this)}</mm-text>
    `;
    }
};
TokenItem.styles = (0, lit_1.css) `
    /* 토큰 묶음 안에서 줄바꿈으로 흐르므로 표면 기본 폭(100%) 대신 내용 폭을 갖는다. */
    :host {
      ${surface_styles_1.surfaceBaseStyles};
      --surface-padding: var(--space-3) var(--space-4);

      width: auto;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TokenItem.prototype, "key", void 0);
TokenItem = __decorate([
    (0, decorators_js_1.customElement)('mm-token-item')
], TokenItem);
exports.TokenItem = TokenItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9rZW4taXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRva2VuLWl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCwrRUFBOEU7QUFDOUUsOEVBQWdGO0FBQ2hGLG1GQUE2RTtBQUM3RSwrQkFBNEI7QUFFNUI7Ozs7R0FJRztBQUVJLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBQWxDOztRQVVHLGdCQUFXLEdBQUcsSUFBSSwrQ0FBcUIsQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUN6QixRQUFHLEdBQUcsRUFBRSxDQUFBO0lBUXRDLENBQUM7SUFOQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTt1REFDd0MsSUFBSSxDQUFDLEdBQUc7eUNBQ3RCLElBQUEsaUNBQWtCLEVBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUM7S0FDdEUsQ0FBQTtJQUNILENBQUM7O0FBakJNLGdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7OztRQUdiLGtDQUFpQjs7Ozs7R0FLdEIsQ0FBQTtBQUUyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7c0NBQVM7QUFYekIsU0FBUztJQURyQixJQUFBLDZCQUFhLEVBQUMsZUFBZSxDQUFDO0dBQ2xCLFNBQVMsQ0FtQnJCO0FBbkJZLDhCQUFTIn0=